import { faThumbtack } from "@fortawesome/free-solid-svg-icons";
import React, { useContext, useEffect, useState } from "react";
import Preloader from "../common/Preloader3";
import SimpleContext from "../context/SimpleContext";
import config from "../../services/config.json";
import axios from "axios";
import plus from "../img/plus.png";
import plus2 from "../img/plus2.png";
import mini from "../img/mini.png";
import { browserName, browserVersion } from "react-device-detect";
const ProductBtn = ({ Product, banner }) => {
  const [firstAdd, setfirstAdd] = useState(false);
  const [forceUpdate, setforceUpdate] = useState(false);
  const [res, setres] = useState([]);
  const [counter, setcounter] = useState(0);
  const context = useContext(SimpleContext);
  const [addC, setaddC] = useState(false);

  //این تابع چک میکند که اگر آبجکت پروداکت پریلودر نداشته باشد ان را ست میکند
  if (Product.showPreloader === undefined) {
    Product.showPreloader = false;
  }

  if (Object.values(Product).length > 0) {
    if (Product.temp === undefined) {
      Product.temp = 0;
    }
  }

  useEffect(() => {
    setaddC(false);
  }, []);

  //برای فراخانی وب سرویس ادد تو کارت 1ونیم ثانیه بعد از کلیک کاربر

  useEffect(() => {
    setaddC(false);
  }, [Product.basketSelection]);

  useEffect(() => {
    setaddC(true);

    if (addC === true) {
      const timer =
        counter > 0 && setInterval(() => setcounter(counter - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [counter, addC]);

  useEffect(() => {
    if (addC === true && counter === 0) {
      handleAddToCardHome(
        1,
        Product.price,
        Product.productRef,
        Product.temp,
        Product.unitName,
        Product.showPreloader,
        Product.banner
      );
    }
  }, [counter]);

  useEffect(() => {
    Product.temp = 0;
  }, [context.resAdd]);

  //تابع برای زمانی که کاربر اولین بار یک محوصل را به سبد خرید اضافه میکند
  function AddOne(
    minimum,
    price,
    productRef,
    basketSelection,
    unitName,
    showPreloader
  ) {
    // alert("12")
    // setadd(true)
    setfirstAdd(true);
    showPreloader = true;
    if (minimum > 0) {
      Product.temp = Product.temp + 1;
      Product.basketSelection =
        parseInt(Product.basketSelection) + parseInt(Product.increaseStep);
      setforceUpdate(!forceUpdate);
      setaddC(true);
      setcounter(1);
    } else if (minimum < 0) {
      Product.temp = Product.temp - 1;
      Product.basketSelection =
        parseInt(Product.basketSelection) - parseInt(Product.increaseStep);
      setforceUpdate(!forceUpdate);
      setaddC(true);
      setcounter(1);
    }
  }

  /*************************************************تابع برای افزودن کالا به سبد خرید***************************************************** */

  const handleAddToCardHome = (
    step,
    price,
    productRef,
    basketSelection,
    unitName,
    showPreloader,
    banner
  ) => {
    Product.showPreloader = true;
    context.setpre(true);
    context.changeView = true;
    context.setchangeView(context.changeView);
    let MyTime = Date.now();
    let TimeHeader = context.Encriptor(MyTime + context.timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .post(
        `${context.baseUrlApiPakhsh}${config.addToCart}`,
        {
          appTypeId: context.AppType,
          customerId:
            Object.values(context.UseInFo).length > 0 &&
            context.UseInFo.customerId,
          isSet: false,
          price: price,
          productId: productRef,
          selection: basketSelection,
          appVersion: browserName,
          AndroidVersion: browserVersion,
          deviceId: context.UniqueUUID,
        },
        { headers: myheaders }
      )
      .then((response) => {
        if (response.data.popUp !== null) {
          if (
            response.data.popUp.text === "" &&
            response.data.popUp.imageLink === ""
          ) {
            window.open(response.data.popUp.link, "noopener,noreferrer");
          } else {
            context.setmodalPopUp(true);
            context.setTextPopUp(response.data.popUp);
          }
        } else {
          context.setmodalPopUp(false);
        }
        if (response.data.popUp !== null) {
          if (
            response.data.popUp.text === "" &&
            response.data.popUp.imageLink === ""
          ) {
            window.open(response.popUp.link, "noopener,noreferrer");
          } else {
            context.setmodalPopUp(true);
            context.setTextPopUp(response.data.popUp);
          }
        } else {
          context.setmodalPopUp(false);
        }
        context.setpre(false);
        if (response.data.code === 200) {
          context.countRowBaskett();
          context.setresAdd(!context.resAdd);
          Product.showPreloader = false;
          Product.basketSelection = response.data.response.selection;
          context.setBadgeOfBasket(response.data.response.countInBasket);
          setres(response.data.response);
          context.setresAddToCart(response.data.response);
          context.setpre(false);
          context.changeView = false;
          context.setchangeView(context.changeView);
        } else if (parseInt(response.data.code, 10) === 400) {
          context.setresAdd(!context.resAdd);
          setaddC(false);
          Product.basketSelection = 0;
        } else if (response.data.code === 401) {
          context.setresAdd(!context.resAdd);
          context.setshowModalTime(true);
        }
      })
      .catch((er) => {
        context.setresAdd(!context.resAdd);
        console.log(er);
      });
  };

  // useEffect(() => {
  //   if (context.changeView === false) {
  //     goSelection();
  //   }
  // }, [context.changeView]);

  //ست کردن اطلاعات محصول برای استفاده در انتخاب مقدار ادد تو کارت
  const showNum = (product) => {
    context.setshowmodalNum(true);
    context.setproductNum(product);
  };

  return (
    <>
      {Product.showPreloader === true ? (
        <div
          className="badgeBuyBtnProduct"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Preloader />
        </div>
      ) : (
        // parseInt(Product.basketSelection) === 0 ? (
        //   <button

        //     onClick={() =>
        //       AddOne(
        //         Product.minimum,
        //         Product.price,
        //         Product.productRef,
        //         Product.basketSelection,
        //         Product.unitName,
        //         Product.showPreloader
        //       )
        //     }

        //     className="ButtonBtnP"
        //   >
        //    {/* <img style={{width:'25px'}} src={plus2}/> */}
        //    {`${Product.basketSelection}${Product.unitName}`}
        //   </button>
        // ) :
        <div className="badgeBuyBtnProduct">
          {parseInt(Product.basketSelection) === Product.stock ? (
            <div
              style={{ backgroundColor: "gray" }}
              className="iconeCatBtnProduct"
            >
              <img src={plus} style={{ width: "15px" }} />
            </div>
          ) : (
            <div
              className="iconeCatBtnProduct"
              onClick={() =>
                AddOne(
                  Product.minimum,
                  Product.price,
                  Product.productRef,
                  Product.basketSelection,
                  Product.unitName,
                  Product.showPreloader
                )
              }
            >
              <img src={plus} style={{ width: "15px" }} />
            </div>
          )}

          <div
            onClick={() => showNum(Product)}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              direction: "ltr",
              gap: "4px",
            }}
          >
            <div style={{ fontSize: "17px" }}>
              {`${Product.basketSelection}${Product.unitName}`}
            </div>
          </div>

          <div
            className="iconeCatBtnProduct"
            onClick={() =>
              Product.basketSelection !== 0 &&
              AddOne(
                -Product.minimum,
                Product.price,
                Product.productRef,
                Product.basketSelection,
                Product.unitName,
                Product.showPreloader
              )
            }
          >
            <img src={mini} style={{ width: "20px" }} />
          </div>
        </div>
      )}
    </>
  );
};

export default ProductBtn;
